(function () {
  if (window.__pdpLanding) return; window.__pdpLanding = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  // Horizon scrolls .page-wrapper on desktop, not window: listen in capture phase
  function onScroll(fn) { document.addEventListener('scroll', fn, { capture: true, passive: true }); window.addEventListener('resize', fn); }

  function initBar(bar) {
    if (bar.dataset.ready) return; bar.dataset.ready = 1;
    var h = $('[data-h]', bar), m = $('[data-m]', bar), s = $('[data-s]', bar);
    function tick() {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var r = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = String(Math.floor(r / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor(r % 3600 / 60)).padStart(2, '0');
      s.textContent = String(r % 60).padStart(2, '0');
    }
    tick(); setInterval(tick, 1000);
  }

  function initDates(root) {
    $$('[data-pdp-date]', root).forEach(function (el) {
      var d = new Date(); d.setDate(d.getDate() + (parseInt(el.dataset.pdpDate, 10) || 0));
      el.textContent = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    });
  }

  function initHero(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = 1;
    var track = $('[data-track]', sec), strip = $('[data-thumbs]', sec);
    var thumbs = $$('[data-thumb]', sec), cur = 0;
    function go(i, fromScroll) {
      if (!thumbs.length) return;
      cur = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
      if (!fromScroll && track.children[cur]) track.scrollTo({ left: track.children[cur].offsetLeft, behavior: 'smooth' });
      var t = thumbs[cur]; if (strip && t) strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, top: t.offsetTop - strip.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = $('[data-prev]', sec), next = $('[data-next]', sec);
    prev && prev.addEventListener('click', function () { go(cur - 1); });
    next && next.addEventListener('click', function () { go(cur + 1); });
    if (track) { var to; track.addEventListener('scroll', function () { clearTimeout(to); to = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) go(i, true); }, 90); }, { passive: true }); }

    // ---- Offers: one radio per variant. All display data comes from Liquid (data-*), so formats match the store.
    var form = $('form.pdp-form', sec), idInput = form && $('[name="id"]', form), btn = $('[data-pdp-add]', sec);
    var planBox = $('[data-plan]', sec), planInput = $('[data-plan-input]', sec);
    var stickyPrice = $('[data-sticky-price]', sec), stickyTitle = $('[data-sticky-title]', sec), stickyImg = $('[data-sticky-img]', sec);
    var offers = $$('[data-offer]', sec);
    var soldOut = sec.dataset.soldOut || 'Sold out';
    function sync(userAction) {
      var o = $('[data-offer]:checked', sec);
      if (!o || !idInput) return;
      idInput.value = o.value;
      if (btn) { btn.disabled = o.disabled; btn.textContent = o.disabled ? soldOut : (btn.dataset.label || btn.textContent); }
      if (stickyPrice) stickyPrice.textContent = o.dataset.price;
      if (stickyTitle) stickyTitle.textContent = o.dataset.title;
      if (stickyImg && o.dataset.img) { stickyImg.src = o.dataset.img; stickyImg.hidden = false; }
      if (!userAction) return;
      if (sec.dataset.jump === 'true' && o.dataset.media) {
        var idx = $$('.pdp-slide', track).findIndex(function (sl) { return sl.dataset.mediaId === o.dataset.media; });
        if (idx > -1) go(idx);
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    }
    offers.forEach(function (i) { i.addEventListener('change', function () { sync(true); }); });
    sync(false);

    function openCart() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var tries = 0;
      (function attempt() {
        if (typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function') {
          Promise.resolve(window.upcartRefreshCart()).catch(function () {}).then(function () { window.upcartOpenCart(); });
        } else if (tries++ < 30) { setTimeout(attempt, 120); } else { window.location.href = '/cart'; }
      })();
    }
    if (form && btn) form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (btn.disabled) return;
      var label = btn.innerHTML; btn.disabled = true; btn.innerHTML = 'Adding…';
      var item = { id: Number(idInput.value), quantity: 1 };
      if (planBox && planInput && planInput.checked && planBox.dataset.plan) item.selling_plan = Number(planBox.dataset.plan);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { btn.disabled = false; btn.innerHTML = label; openCart(); })
        .catch(function (err) { btn.disabled = false; btn.textContent = (err && err.description) || 'Please try again'; setTimeout(function () { btn.innerHTML = label; }, 2200); });
    }, true);

    var sticky = $('[data-sticky]', sec);
    if (sticky && btn) {
      var raf = 0;
      var upd = function () { raf = 0; var r = btn.getBoundingClientRect(); var on = r.bottom < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); };
      onScroll(function () { if (!raf) raf = requestAnimationFrame(upd); }); upd();
      var sb = $('[data-sticky-add]', sticky);
      sb && sb.addEventListener('click', function () { if (!btn.disabled) form.requestSubmit ? form.requestSubmit() : btn.click(); });
    }
  }

  function initCarousel(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = 1;
    var row = $('[data-row]', sec), dots = $('[data-dots]', sec), prev = $('[data-prev]', sec), next = $('[data-next]', sec);
    if (!row) return;
    function per() { var c = row.children[0]; return c ? Math.max(1, Math.round(row.clientWidth / (c.getBoundingClientRect().width + 18))) : 1; }
    function pages() { return Math.max(1, Math.ceil(row.children.length / per())); }
    function page() { return Math.round(row.scrollLeft / Math.max(1, row.clientWidth)); }
    function to(i) { row.scrollTo({ left: i * row.clientWidth, behavior: 'smooth' }); }
    function build() {
      if (!dots) return; dots.innerHTML = '';
      for (var i = 0; i < pages(); i++) (function (i) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Page ' + (i + 1)); b.onclick = function () { to(i); }; dots.appendChild(b); })(i);
      mark();
    }
    function mark() {
      var p = page(), n = pages();
      if (dots) [].forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === p); });
      if (prev) prev.disabled = p <= 0; if (next) next.disabled = p >= n - 1;
    }
    prev && prev.addEventListener('click', function () { to(Math.max(0, page() - 1)); });
    next && next.addEventListener('click', function () { to(Math.min(pages() - 1, page() + 1)); });
    row.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
    window.addEventListener('resize', build); build();
  }

  function initAll(root) {
    root = root || document;
    $$('[data-pdp-bar]', root).forEach(initBar);
    $$('[data-pdp-hero]', root).forEach(initHero);
    $$('[data-pdp-carousel]', root).forEach(initCarousel);
    initDates(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
